import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import BaseModal from './BaseModal';
import { inputTypes } from '../../utils/inputTypes';
import ModalForm from './ModalForm';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { createNew, editCompany } from '../../actions/companyActions'
import { showSnackbar, closeSnackbar } from "../../actions/snackbarActions";

const styles = theme => ({

});

class CompanyModal extends React.Component {

  constructor(props) {
    super(props);

    // Array of inputs that dynamically build
    // up the editor form.
    this.formFields = [
      {
        id: "name",
        name: "name",
        label: "Company Name",
        type: inputTypes.textField,
        value: ""
      },
      {
        id: "address",
        name: "address",
        label: "Address",
        type: inputTypes.textField,
        value: ""
      },
      {
        id: "city",
        name: "city",
        label: "City",
        type: inputTypes.textField,
        value: ""
      },
      {
        id: "businessId",
        name: "businessId",
        label: "Business ID",
        type: inputTypes.textField,
        value: ""
      }
    ];
  }

  // This function is called by the child component
  // (<BaseModal>) during its own submit function
  onSubmit = async (values) => {
    // Different action needs to be fired, depending on
    // whether creating new company or editing one.
    if (this.props.isEdit && this.props.selectedCompany) {
      const id = this.props.selectedCompany.id;
      const editedCompany = {...values, id};
      await this.props.editCompany(editedCompany);
      this.props.showSnackbar("Company edited");
    } else {
      await this.props.createNew(values);
      this.props.showSnackbar("New company created");
    }
  }

  // Validation schema can be difficult to build dynamically
  // in the child component. For easiness, it's created here
  // and then passed down as prop
  validationSchema = Yup.object().shape({
    name: Yup.string().label("Company name").required().min(2),
    address: Yup.string().label("Address").required().min(2),
    city: Yup.string().label("City").required().min(2),
    businessId: Yup.string().label("Business ID").required().min(4)
  });

  render() {
    const {isOpen, handleClose, isEdit, selectedCompany } = this.props;

    return (
      <BaseModal isEdit={isEdit} modalType="Company" onSubmit={this.onSubmit} isOpen={isOpen} handleClose={handleClose}>
        <ModalForm validationSchema={this.validationSchema} initialValues={selectedCompany} formFields={this.formFields} handleCancel={handleClose} />
      </BaseModal>
    )
  }
}
export default
  compose(
    withStyles(styles),
    connect(null, { createNew, editCompany, showSnackbar, closeSnackbar })
  )(CompanyModal);


// WEBPACK FOOTER //
// ./src/components/Modals/CompanyModal.js